import { useRxCollectionFacility } from "$global-providers/rxdb-provider/collections/facility";
import { useRxQuery } from "rxdb-hooks";

export const useFacilityName = (
  facilityId: string | null | undefined,
): string | undefined => {
  const facilityCollection = useRxCollectionFacility();
  const { result: facilities } = useRxQuery(
    facilityId
      ? facilityCollection?.find({ selector: { id: { $eq: facilityId } } })
      : undefined,
  );

  return facilities?.[0]?.name;
};
